// extracted by mini-css-extract-plugin
export default {"container":"Row_container__HzMO+","label":"Row_label__VWkQe"};